// extracted by mini-css-extract-plugin
export default {"timesheet-phases-table":"timesheet-phases_timesheet-phases-table__EMlYq","delete-icon":"timesheet-phases_delete-icon__mf+Wf"};